/**
 * Utility functions for meal selection and distribution
 */

import {
    filterRecipesByAllergies as filterByAllergies,
    getRecipePriorityIndex,
    sortRecipesByPriority as sortByPriority,
    autoDistributePacks,
} from "@/helpers/mealDistribution";

export type LocalRecipe = {
    id: string;
    title: string;
    handle?: string;
    image?: any;
    variantId: string;
    grams: number;
    price: number;
    variant: any;
};

/**
 * Get priority index for a recipe title — delegates to the canonical helper
 * so the priority order lives in exactly one place.
 */
export function getPriorityIndex(title: string): number {
    return getRecipePriorityIndex(title);
}

/**
 * Automatically distribute packs across recipes — delegates to the canonical
 * helper (even baseline, leftovers round-robin in priority order).
 */
export function autoDistribute(
    sortedRecipes: LocalRecipe[],
    totalPacks: number
): Record<string, number> {
    return autoDistributePacks(sortedRecipes, totalPacks);
}

/**
 * Filter recipes by allergies — delegates to the canonical helper so the
 * allergy synonym + hidden-allergen rules live in exactly one place.
 */
export function filterRecipesByAllergies(
    recipes: LocalRecipe[],
    allergies: string[]
): LocalRecipe[] {
    return filterByAllergies(recipes, allergies);
}

/**
 * Sort recipes by priority — delegates to the canonical helper.
 */
export function sortRecipesByPriority(recipes: LocalRecipe[]): LocalRecipe[] {
    return sortByPriority(recipes);
}
